import log from '@/utils/consolelog'
import warnings from '@/api/modules/warnings'
import * as mutations from './mutations'

const initialState = {
	data: [],
	loading: false,
	error: null
}

export default {
	state: Object.assign({}, initialState),
	getters: {
		getAlerts: state => state.data,
		getAlertsLoading: state => state.loading,
		getAlertsError: state => state.error
	},
	mutations: {
		[mutations.SET_ALERTS] (state, value) {
			state.data = value
		},
		[mutations.SET_ALERTS_LOADING] (state, value) {
			state.loading = value
		},
		[mutations.SET_ALERTS_ERROR] (state, value) {
			state.error = value
		},
		[mutations.CLEAR_ALERTS] (state) {
			Object.assign(state, initialState)
		}
	},
	actions: {
		setAlerts ({ commit }, value) {
			commit(mutations.SET_ALERTS, value)
		},
		setAlertsLoading ({ commit }, value) {
			commit(mutations.SET_ALERTS_LOADING, value)
		},
		getAlerts ({ commit, state }, { context, user_uid }) {
			//if (!state.loading) {
				commit(mutations.SET_ALERTS_LOADING, true)
				warnings.getAll(context, user_uid).then(response => {
					log.log('store', 'alerts.getAll OK', response)()
					const alerts = response.body
					commit(mutations.SET_ALERTS, alerts)
				}).catch(errors => {
					log.error('store', 'alerts.getAll ERROR', errors)()
					commit(mutations.SET_ALERTS_ERROR, errors)
				}).finally(() => {
					commit(mutations.SET_ALERTS_LOADING, false)
				})
			//}
		}
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/alerts.js